import { CustomerContract } from '@litlingo/client';
import { downloadContract } from 'actions/customerContracts';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CreateCustomerContractModal from './CreateCustomerContractModal';

type ComponentProps = {
  contract: CustomerContract;
};

const CustomerContractListItem: React.FC<ComponentProps> = ({ contract }) => {
  const dispatch = useDispatch();

  const [isCreatingNew, setIsCreatingNew] = useState(false);

  const toggleIsCreatingNew = (): void => {
    setIsCreatingNew(!isCreatingNew);
  };

  const handleContractLinkClick = (): void => {
    dispatch(downloadContract({ contractId: contract.uuid }));
  };

  return (
    <>
      <tr className="row-hover table-row border-t border-gray-200 align-middle hover:bg-litlingo-gray-0">
        <td className="table-wrapper__new-td">
          <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
            <div className="pl-4 py-2 flex flex-col gap-1">
              <div>
                {moment(contract.start_date).format('MM/DD/YYYY')} -{' '}
                {contract.end_date ? moment(contract.end_date).format('MM/DD/YYYY') : 'Present'}
              </div>
              <div>
                {contract.end_date
                  ? `${moment(contract.end_date).diff(
                      moment(contract.start_date),
                      'months'
                    )} months`
                  : 'Livestream'}
              </div>
            </div>
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            {contract.insight_seats}
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            {contract.prevent_seats}
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            {contract.users_list_filename && (
              <>
                <span className="max-w-32 truncate">
                  {contract.users_list_filename?.split('.')[0]}
                </span>
                <span className="">.{contract.users_list_filename?.split('.').pop()}</span>
              </>
            )}
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            {contract.contract_filename && (
              <button
                type="button"
                className="flex flex-row focus:outline-none"
                onClick={handleContractLinkClick}
              >
                <span className="max-w-32 truncate underline">
                  {contract.contract_filename?.split('.')[0]}
                </span>
                <span className="underline">.{contract.contract_filename?.split('.').pop()}</span>
              </button>
            )}
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            {contract.notes}
          </div>
        </td>
        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-12 m-0 p-0 flex text-body items-center">
            <button
              type="button"
              onClick={toggleIsCreatingNew}
              className="row-hover-conditional hidden text-litlingo-primary underline focus:outline-none"
            >
              View
            </button>
          </div>
        </td>
      </tr>
      {isCreatingNew && (
        <CreateCustomerContractModal
          contract={contract}
          isModalOpen={isCreatingNew}
          toggleModalOpen={toggleIsCreatingNew}
        />
      )}
    </>
  );
};

export default CustomerContractListItem;
